import { IconButton } from '@liveauctioneers/hammer-ui-core/iconButton';
import { Close } from '@liveauctioneers/hammer-ui-core/icons';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H2 } from '@liveauctioneers/hammer-ui-core/text';
import { memo, MouseEvent as ReactMouseEvent } from 'react';
import isEqual from 'react-fast-compare';

import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';
import { ButtonLocation } from '@/utils/amplitude/analytics';

type Props = {
    currentImageIndex: number;
    galleryLength: number;
    galleryTitle: string;
    itemId: number;
    onClose: (event: ReactMouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const LightboxHeaderComponent = ({ currentImageIndex, galleryLength, galleryTitle, itemId, onClose }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <>
            {/* Header content */}
            <header className="z-10 select-none bg-surface-100 px-[20px] py-xs">
                <div className="flex items-center justify-between">
                    <H2>{galleryTitle}</H2>
                    <IconButton
                        icon={Close}
                        onClick={onClose}
                    />
                </div>
            </header>
            {/* Relative pagination and favorite button container */}
            <div className="relative">
                {/* Absolute container */}
                <div className="absolute left-0 right-0 flex items-center justify-between p-[20px] [&>*]:z-10">
                    <div className="flex items-center justify-center rounded-[4px] bg-surface-500 px-[12px] py-[3px] opacity-[0.85] [&_span]:text-text-inverse">
                        <BodyPrimary>
                            {formatMessage(
                                { id: 'lightbox.header' },
                                {
                                    currentImage: currentImageIndex + 1,
                                    galleryLength,
                                }
                            )}
                        </BodyPrimary>
                    </div>
                    <ItemSaveContainer
                        buttonLocation={ButtonLocation.LDPImageGallery}
                        itemId={itemId}
                    />
                </div>
            </div>
        </>
    );
};

export const LightboxHeader = memo<Props>(LightboxHeaderComponent, isEqual);
